module.exports = __webpack_public_path__ + "media/shivaaura3.95a78555.webm";